export enum ProvinceEnum {
  EasternCape = 0,
  FreeState = 1,
  Gauteng = 2,
  KwaZuluNatal = 3,
  Limpopo = 4,
  Mpumalanga = 5,
  NorthernCape = 6,
  NorthWest = 7,
  WesternCape = 8,
}

export enum ProvinceDescription {
  'Eastern Cape' = 0,
  'Free State' = 1,
  'Gauteng' = 2,
  'KwaZulu-Natal' = 3,
  'Limpopo' = 4,
  'Mpumalanga' = 5,
  'Northern Cape' = 6,
  'North West' = 7,
  'Western Cape' = 8,
}

export const provinceValues: ProvinceEnum[] = Object.values(ProvinceEnum).filter(
  (value): value is ProvinceEnum => typeof value === 'number',
);
